export default "__VITE_ASSET__Dt_JzD3m__"